import makeApp from "../shared/make_app";

import * as dhsa from "../shared/actions/data_hub_search";
import * as loadingActions from "../shared/actions/loading";
import * as focusViewActions from "./actions/focus_view";
import Root from "./containers/root";

const focusView = (state = {}, action) => {
  switch(action.type) {
  case focusViewActions.BREADCRUMBS_CLICK_OVERVIEW:
  case dhsa.SAVED_SEARCH_SELECTED:
    return {
      type: focusViewActions.FOCUS_VIEW_OVERVIEW,
      lockFilterBox: false,
      overview: {
        title: "Overview of standards"
      }
    };
  case loadingActions.DATA_LOADED:
    return Object.assign({}, state, { lockFilterBox: state.type !== focusViewActions.FOCUS_VIEW_OVERVIEW });
  default:
    return state;
  }
};

export default makeApp(Root, focusView);
